AppTabs.createTab( {
name: 'test-combo-management',
icon: 'vial',
text: 'Test Combo Management',
create: function() {
    'use strict'

    return new TabControllerVue({
        el: '#vue-test-combo-management',
        // store, // vuex store
        lockUpdates: true,
        methods: {
            resetData() {
                this.testCombo      = null;
                this.testComboTests = [];
            },

            /*******
             * AJAX
             */
            addTestCombo: function() {
                const _this = this;
                window.InputModalManager.show({
                    title 		: 'Add New Test Combo',
                    inputText   : '',
                    buttonText	: 'Add Test Combo',
                    callback 	: function( name ) {
                        if ( name ) {
                            window.ajaxCall({
                                data : {
                                    action: 'add_test_combo',
                                    name: name,
                                },
                                successMessage: 'Successfully Added Test Combo',
                                onSuccess : function( response ) {
                                    // store new combo list in local data
                                    window.LocalStorageManager.set( 'testComboList', response.data.testComboList );
                                    // refresh in Vuex store
                                    window.LocalStorageManager.populateStore( 'testComboList' );
                                    // set selected test combo
                                    const newTestCombo = _this.testCombos
                                        && _this.testCombos.find( combo => combo.id == response.data.id ) || null;
                                    _this.testCombo = newTestCombo;
                                }
                            });
                        } else {
                            window.ajaxNotificationManager.warning( 'A name is required when adding a Test Combo!' );
                        }
                    },
                });
            },

            renameTestCombo: function() {
                const _this = this;
                const oldName = this.testCombo.text;
                window.InputModalManager.show({
                    title       : 'Rename Test Combo',
                    inputText   : this.testComboName,
                    buttonText  : 'Rename Test Combo',
                    callback    : function( name ) {
                        if ( name ) {
                            window.ajaxCall({
                                data : {
                                    action: 'rename_test_combo',
                                    test_combo_id: _this.testComboId,
                                    name: name,
                                },
                                successMessage: 'Successfully Renamed Test Combo',
                                onSuccess: function( response ) {
                                    // store new combo list in local data
                                    window.LocalStorageManager.set( 'testComboList', response.data.testComboList );
                                    // refresh in Vuex store
                                    window.LocalStorageManager.populateStore( 'testComboList' );
                                    // set selected test combo
                                    const newTestCombo = _this.testCombos
                                        && _this.testCombos.find( combo => combo.id == response.data.id ) || null;
                                    _this.testCombo = newTestCombo;
                                },
                                onError: function () {
                                    _this.testCombo.text = oldName;
                                }
                            });
                        } else {
                            window.WarningModalManager.show( { message: 'A name is required when renaming a Test Combo!' } );
                        }
                    },
                });
            },

            deleteTestCombo: function() {
                const _this = this;
                const id = this.testComboId
                window.ConfirmationModalManager.show({
                    title       : 'Confirm Test Combo Deletion',
                    message     : 'Are you sure you want to permanently delete "' + this.testComboName + '"?',
                    buttonText	: 'Delete',
                    callback 	: function() {
                        _this.testCombo = null;
                        window.ajaxCall({
                            data : {
                                action: 'delete_test_combo',
                                test_combo_id: id,
                            },
                            successMessage: 'Successfully Deleted Test Combo',
                            onSuccess: function( response ) {
                                // store new combo list in local data
                                window.LocalStorageManager.set( 'testComboList', response.data.testComboList );
                                // refresh in Vuex store
                                window.LocalStorageManager.populateStore( 'testComboList' );
                            },
                            onError: function() {
                                // set selected test combo
                                const newTestCombo = _this.testCombos
                                    && _this.testCombos.find( combo => combo.id == id ) || null;
                                _this.testCombo = newTestCombo;
                            },
                        });
                    },
                });
            },

            loadTestComboTestsResponse: function( data ) {
                this.testComboTests = data;
                this.unlockUpdatesLater( 'loadTestComboTestsResponse' );
            },
            addTestToComboList: function(testId) {
                if ( ! this.testComboId ) { return; }
                if ( this.getUpdateLockLevel() ) { return; }
                this.lockUpdates( 'loadTestListTests' );
                const _this = this;
                let testIdArray = testId.split(",");
                window.ajaxCall({
                    data : {
                        action: 'add_test_to_combo_list',
                        test_combo_id: this.testComboId,
                        test_ids: testIdArray,
                        sample_id: -1
                    },
                    successMessage: 'Successfully Added Combo Test',
                    onSuccess : function(response) {
                        _this.loadTestComboTestsResponse(response.data);
                    },
                    onError : _this.unlockUpdates,
                });
            },
            removeTestFromComboList: function(testId) {
                if ( ! this.testComboId ) { return; }
                if ( this.getUpdateLockLevel() ) { return; }
                this.lockUpdates( 'loadTestListTests' );
                const _this = this;
                let testIdArray = testId.split(",");
                window.ajaxCall({
                    data : {
                        action: 'remove_test_from_combo_list',
                        test_combo_id: this.testComboId,
                        test_ids: testIdArray
                    },
                    successMessage: 'Successfully Removed Combo Test',
                    onSuccess : function(response) {
                        _this.loadTestComboTestsResponse(response.data);
                    },
                    onError : _this.unlockUpdates,
                });
            },
            loadTestComboTests: function() {
                if ( !  this.testComboId ) { return; }
                if ( this.getUpdateLockLevel() ) { return; }
                this.lockUpdates( 'loadTestListTests' );
                const _this = this;
                window.ajaxCall({
                    data: {
                        action: 'get_combo_tests_by_id',
                        test_combo_id:  this.testComboId
                    },
                    successMessage: 'Successfully Loaded Test Combo Tests',
                    onSuccess : function(response){
                        let data = response.data;
                        _this.loadTestComboTestsResponse(data);
                    },
                    onError : _this.unlockUpdates,
                });
            },

            updateTestComboTests: function(selectedTestIds) {
                if ( ! this.testComboId ) { return; }
                if ( this.getUpdateLockLevel() ) { return; }
                this.lockUpdates( 'loadTestListTests' );
                const _this = this;
                window.ajaxCall({
                    data : {
                        action: 'update_test_combo',
                        test_combo_id: this.testComboId,
                        test_ids: selectedTestIds,
                    },
                    successMessage: 'Successfully Updated Test Combo',
                    onSuccess : _this.loadTestComboTestsResponse,
                    onError : _this.unlockUpdates,
                });
            },

        },
        computed: {
            testComboName: function() {
                return null !== this.testCombo ? this.testCombo.text : null;
            },
            testComboId: function() {
                return null !== this.testCombo ? this.testCombo.id : null;
            },
            testCombos: function() {
                return store.state.testComboList;
            },
            testList: function() {
                return store.state.testList;
            },
        },
        watch: {
            testCombo: function() {
                this.loadTestComboTests();
            }
        }
    } );
}

} );
